import { render, staticRenderFns } from "./SectionsSuc.vue?vue&type=template&id=b4f515c0&scoped=true"
import script from "./SectionsSuc.vue?vue&type=script&lang=js"
export * from "./SectionsSuc.vue?vue&type=script&lang=js"
import style0 from "./SectionsSuc.vue?vue&type=style&index=0&id=b4f515c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4f515c0",
  null
  
)

export default component.exports